export default __webpack_public_path__ + "static/media/chevron-down.a5c31d0f.svg";